export default "__VITE_ASSET__BrgyXHri__"